import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { Button } from "semantic-ui-react";

import { commands$ } from "./CommandsStream";

import { formatTime } from "./utils";
import { OptionsStore } from "./OptionsStore";
import { atom, useRecoilState, useRecoilValue } from "recoil";
import { DarkThemes, TimerFace } from "./TimerFace";

export const snoozeRemain = atom({
  key: "snoozeRemain",
  default: OptionsStore.restore().snoozeDuration,
});

export const snoozeRunning = atom({
  key: "snoozeRunning",
  default: false,
});

let timerId = null

function startBlackScreenTimer() {
  timerId = setTimeout(() => {
    timerId = null

    const div = document.querySelector(".snooze-black");

    if (!div) return;

    div.classList.add("snooze-black-enabled");
  }, 5000);
}

export function Snooze({ onStop }) {
  const [remain, setRemain] = useRecoilState(snoozeRemain);
  const [running, setRunning] = useRecoilState(snoozeRunning);

  const body = document.querySelector("body");

  useEffect(() => {
    if (running) setRemain(OptionsStore.restore().snoozeDuration);

    running ? commands$.play() : commands$.stop();
  }, [running, setRemain]);

  useEffect(() => {
    if (!running) return;

    startBlackScreenTimer();

    return () => clearTimeout(timerId);
  }, [running]);

  const revealTimer = () => {
    clearTimeout(timerId)

    startBlackScreenTimer()

    const div = document.querySelector(".snooze-black");

    if (!div) return;

    div.classList.remove("snooze-black-enabled");
  };

  return ReactDOM.createPortal(
    <>
      <div className="snooze">
        <Timer />
        <div className="snooze-commands">
          <Button
            size="huge"
            onClick={() => {
              setRemain(OptionsStore.restore().snoozeDuration);
              commands$.stop();
              onStop();
            }}
          >
            Close
          </Button>

          <Button size="huge" onClick={() => setRunning((f) => !f)}>
            {running ? "Stop" : "Start"}
          </Button>
        </div>

        {!running && (
          <div className="snooze-ui-timer">
            <TimerFace
              active
              value={remain / 60}
              theme={DarkThemes.black}
              onValue={(value) => {
                setRemain(value * 60);
                OptionsStore.save({ snoozeDuration: value * 60 });
              }}
            />
          </div>
        )}
      </div>
      <div
        className="snooze-black"
        onClick={() => revealTimer()}
        onMouseMove={() => revealTimer()}
      ></div>
    </>,
    body
  );
}

function Timer() {
  const running = useRecoilValue(snoozeRunning);
  const [remain, setRemain] = useRecoilState(snoozeRemain);

  useEffect(() => {
    if (!running) return;

    if (remain <= 0) {
      commands$.stop();
      return;
    }

    const timerId = setTimeout(() => {
      setRemain((remain) => remain - 1);
    }, 1000);

    return () => {
      clearTimeout(timerId);
    };
  }, [remain, running, setRemain]);

  return (
    <div className="snooze-timer">
      <span>{formatTime(remain)}</span>
    </div>
  );
}
